/**
 * 倍率の入力（食事シートの下の帯と、お気に入りの一覧で共通）
 *
 * 数字を直接打って書き換えられる。▲▼・矢印キーは 0.5 刻み。範囲外や打ちかけの値は確定しない
 */

import { useState } from 'react'

import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

import { formatMultiplier, MAX_MULTIPLIER, parseMultiplier } from './multiplier'

const STEP = 0.5

type Props = {
  value: number
  onChange: (value: number) => void
  className?: string
  'aria-label'?: string
}

export function MultiplierInput({ value, onChange, className, 'aria-label': ariaLabel = '倍率' }: Props) {
  // 打っている途中（"1." や空欄）を消さないよう、フォーカス中は打った文字をそのまま出す
  const [draft, setDraft] = useState<string | null>(null)

  return (
    <Input
      type="number"
      inputMode="decimal"
      // min を付けると ▲▼ の刻みが min 起点（0.1, 0.6, 1.1…）になるので、範囲は parseMultiplier で確かめる
      step={STEP}
      max={MAX_MULTIPLIER}
      aria-label={ariaLabel}
      value={draft ?? formatMultiplier(value)}
      onFocus={() => setDraft(formatMultiplier(value))}
      onChange={(e) => {
        setDraft(e.target.value)
        const next = parseMultiplier(e.target.value)
        if (next !== null) onChange(next)
      }}
      onBlur={() => setDraft(null)}
      className={cn('h-6 w-14 px-1 text-center text-xs tabular-nums', className)}
    />
  )
}
